var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _vm.search.length > 0
            ? _c("oaFromBox", {
                attrs: {
                  search: _vm.search,
                  isViewSearch: false,
                  total: _vm.total,
                  title: "班次列表",
                  isAddBtn: true,
                },
                on: { addDataFn: _vm.addFn, confirmData: _vm.confirmData },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-box mt10" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, height: _vm.tableHeight },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "班次名称", width: "200" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "position",
                      label: "考勤时间",
                      width: "340",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.times[0].first_day_after == 0
                                    ? "当日"
                                    : "次日"
                                ) +
                                " " +
                                _vm._s(scope.row.times[0].work_hours) +
                                " -\n            " +
                                _vm._s(
                                  scope.row.times[0].second_day_after == 0
                                    ? "当日"
                                    : "次日"
                                ) +
                                _vm._s(scope.row.times[0].off_hours) +
                                "\n            "
                            ),
                            scope.row.times.length > 1
                              ? _c("span", [
                                  _vm._v(
                                    "、 " +
                                      _vm._s(
                                        scope.row.times[1].first_day_after == 0
                                          ? "当日"
                                          : "次日"
                                      ) +
                                      "\n              " +
                                      _vm._s(scope.row.times[1].work_hours) +
                                      " - " +
                                      _vm._s(
                                        scope.row.times[1].second_day_after == 0
                                          ? "当日"
                                          : "次日"
                                      ) +
                                      _vm._s(scope.row.times[1].off_hours) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "card.name", label: "创建人" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.card ? scope.row.card.name : "--"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "created_at", label: "创建时间" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "updated_at", label: "最后更新时间" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "180", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["hr:attendance:shift:check"],
                                    expression: "['hr:attendance:shift:check']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.checkFn(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["hr:attendance:shift:edit"],
                                    expression: "['hr:attendance:shift:edit']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editFn(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            scope.row.id !== 2
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["hr:attendance:shift:delete"],
                                        expression:
                                          "['hr:attendance:shift:delete']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteFn(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "page-size": _vm.where.limit,
                      "current-page": _vm.where.page,
                      "page-sizes": [15, 20, 30],
                      layout: "total,sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("addShift", { ref: "addShift", on: { getList: _vm.getList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }